import { HelpCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface HelpTooltipProps {
  /** Short preview text shown on hover */
  tip: string;
  /** Article ID in the Help Center (e.g. "gl-1" for IRR) */
  articleId: string;
  /** Optional size override */
  size?: number;
  className?: string;
}

/**
 * Contextual help icon that shows a tooltip on hover
 * and navigates to the relevant Help Center article on click.
 */
export const HelpTooltip = ({ tip, articleId, size = 3.5, className = "" }: HelpTooltipProps) => {
  const navigate = useNavigate();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate(`/help-center?article=${articleId}`);
          }}
          className={`inline-flex items-center justify-center text-muted-foreground hover:text-accent transition-colors ${className}`}
          aria-label="Learn more"
        >
          <HelpCircle style={{ width: `${size * 4}px`, height: `${size * 4}px` }} />
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[220px] text-xs">
        <p>{tip}</p>
        <p className="text-accent mt-1 font-medium">Click to learn more →</p>
      </TooltipContent>
    </Tooltip>
  );
};
